import React from 'react';

import { componentMap } from '../constants';

interface ManageGapAnalysisBodyProps {
    context: GapAnalysisContext;
    remove(removeModalInput: RemoveModalInput): void;
    send: SendGapAnalysisEvent;
}

/**
 * Content for a modal that allows the user to create a Gap Analysis report. Setting this aside in
 * its own component makes it possible to quickly mock out each step with Storybook; see example in:
 * packages/web/src/components/modals/CreateGapAnalysis/components/steps/AnalyzingData/AnalyzingData.story.tsx
 * @param props - {@link ModalContentProps}
 */
export const ManageGapAnalysisBody = ({
    context,
    remove,
    send,
}: ManageGapAnalysisBodyProps): JSX.Element | null => {
    const { stepHistory } = context;
    const currentStepId = stepHistory?.[stepHistory.length - 1] ?? null;

    if (currentStepId === null) {
        return null;
    }

    const CurrentStepComponent = componentMap[currentStepId];

    return (
        <CurrentStepComponent
            context={context}
            remove={remove}
            send={send}
            stepId={currentStepId}
        />
    );
};
